import { useContext } from "react";

import { LimitModalContext } from "./index";

export function useLimitModal() {
  return useContext(LimitModalContext);
}
